import { create } from 'zustand';
import dayjs from 'dayjs';
import { LinhaTempo } from '../../@types/linha-tempo';
import { LocalStorageService } from '../../services';
import { LinhaTempoFiltros } from './types';

type LinhaTempoState = {
  itens: LinhaTempo[];
  filtros: LinhaTempoFiltros;
};

type LinhaTempoActions = {
  fetchItens: () => Promise<void>;
  clear: () => void;
  setFiltros: (filtros: LinhaTempoFiltros) => void;
};

const initialState: LinhaTempoState = {
  itens: [],
  filtros: {
    viewMode: 'currentWeek',
    cultura: undefined,
    registro: undefined,
    talhao: undefined,
    usuario: undefined,
  },
};

const sleep = (timer: number) =>
  new Promise((resolver) => {
    setTimeout(resolver, timer);
  });

const useLinhaTempoStore = create<LinhaTempoState & LinhaTempoActions>(
  (set) => ({
    ...initialState,
    clear: () => set(initialState),

    setFiltros: (filtros) => set({ filtros }),

    fetchItens: async () => {
      await sleep(3000);

      const initialDate = dayjs().startOf('week');

      let currentId = 0;
      const getId = () => currentId++;

      const glebas =
        LocalStorageService.getItem('currentPropriedade')?.glebas || [];

      if (glebas.length < 2) return;

      set({
        itens: [
          {
            id: getId(),
            dataInicio: initialDate.toDate(),
            dataTermino: initialDate.toDate(),
            tipo: 'tarefa',
            talhao: glebas[0],
          },
          {
            id: getId(),
            dataInicio: initialDate.toDate(),
            dataTermino: initialDate.toDate(),
            tipo: 'ocorrencia',
            talhao: glebas[0],
          },

          {
            id: getId(),
            dataInicio: initialDate.add(1, 'day').toDate(),
            dataTermino: initialDate.add(1, 'day').toDate(),
            tipo: 'anotacao',
            talhao: glebas[0],
          },
          {
            id: getId(),
            dataInicio: initialDate.add(2, 'day').toDate(),
            dataTermino: initialDate.add(4, 'day').toDate(),
            tipo: 'tratamentoSementes',
            talhao: glebas[0],
          },
          {
            id: getId(),
            dataInicio: initialDate.add(4, 'day').toDate(),
            dataTermino: initialDate.add(10, 'day').toDate(),
            tipo: 'tratamentoSementes',
            talhao: glebas[0],
          },

          {
            id: getId(),
            dataInicio: initialDate.add(2, 'day').toDate(),
            dataTermino: initialDate.add(2, 'day').toDate(),
            tipo: 'anotacao',
            talhao: glebas[1],
          },
          {
            id: getId(),
            dataInicio: initialDate.add(6, 'day').toDate(),
            dataTermino: initialDate.add(6, 'day').toDate(),
            tipo: 'tratamentoSementes',
            talhao: glebas[1],
          },
          {
            id: getId(),
            dataInicio: initialDate.add(6, 'day').toDate(),
            dataTermino: initialDate.add(8, 'day').toDate(),
            tipo: 'anotacao',
            talhao: glebas[1],
          },
        ],
      });
    },
  }),
);

export default useLinhaTempoStore;
